import { useEffect, useState } from "react";
import { authorize_net_accept_js } from "../services/common.services";

export function useAcceptJS() {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        // If Accept.js is already on window, skip
        if ((window as any).Accept) {
            setLoaded(true);
            return;
        }

        const script = document.createElement("script");
        script.src = authorize_net_accept_js;
        script.async = true;
        script.onload = () => {
            if ((window as any).Accept) {
                setLoaded(true);
            } else {
                setError("Accept.js loaded but window.Accept is undefined.");
            }
        };
        script.onerror = () => {
            setError("Failed to load Accept.js script.");
        };

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return { loaded, error, accept: (window as any).Accept };
}
